/*
 * @Author: 任晓帅
 * @Contact: VX:ren18321147631
 * @Date: 2026-02-15 08:43:12
 * @Description: 不可进行二次销售
 */
// utils/directive.js
import Vue from 'vue'

// 权限指令
const permission = {
  inserted(el, binding) {
    const { value } = binding
    if (value && value.length > 0) {
      const hasPermission = checkPermission(value)
      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    }
  }
}

// 焦点指令
const focus = {
  inserted(el) {
    el.focus()
  }
}

// 数字输入限制
const numberOnly = {
  bind(el) {
    el.addEventListener('input', () => {
      el.value = el.value.replace(/[^0-9]/g, '')
    })
  }
}

// 辅助函数
function checkPermission(value) {
  // 实现权限检查逻辑
  return true
}

// 导出安装方法
export default {
  install(Vue) {
    Vue.directive('permission', permission)
    Vue.directive('focus', focus)
    Vue.directive('number-only', numberOnly)
    // 注册其他指令...
  }
}